import { render, staticRenderFns } from "./DisabledSymbols.vue?vue&type=template&id=78378cc3"
import script from "./DisabledSymbols.vue?vue&type=script&lang=js"
export * from "./DisabledSymbols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports